import styles from "./Philosophy.module.css";

/**
 * Philosophy — the "modern software is loud" moment from the direction
 * doc, expressed as a side-by-side comparison: chaotic noise on the left
 * (modern apps), the Atlas Desk antidote on the right. Doesn't try to
 * literally simulate notifications stacking; the structured contrast
 * carries the message.
 */
export function Philosophy() {
  return (
    <section
      id="philosophy"
      className={styles.section}
      aria-labelledby="philosophy-title"
    >
      <div className={`atlasContainer ${styles.inner}`}>
        <header className={styles.header}>
          <span className="atlasEyebrow">Philosophy</span>
          <h2 id="philosophy-title" className={styles.title}>
            Modern software became loud.
            <br />
            <span className={styles.titleAccent}>
              Atlas brings back the quiet.
            </span>
          </h2>
        </header>

        <div className={styles.compare}>
          <article className={`${styles.column} ${styles.columnNoisy}`}>
            <span className={styles.colTag}>Most software</span>
            <ul className={styles.list}>
              <li>Fights for your attention.</li>
              <li>Features piled on features.</li>
              <li>Pings, badges, banners.</li>
              <li>Cloud-first. Ownership second.</li>
            </ul>
          </article>

          <div className={styles.divider} aria-hidden />

          <article className={`${styles.column} ${styles.columnCalm}`}>
            <span className={styles.colTag}>Atlas Desk</span>
            <ul className={styles.list}>
              <li>Stays out of your way.</li>
              <li>Each app has one job.</li>
              <li>No upsells.</li>
              <li>Offline.</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
